import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import type CustomerRefundCandidateDetailViewModel from "viewModels/finance/customerRefunds/customerRefundCandidates/customerRefundCandidateDetailViewModel";
import { observer } from "mobx-react-lite";
import Section from "views/common/section";
import { Col, Form } from "react-bootstrap";
import type RejectedCustomerRefundCandidateDetailViewModel from "viewModels/finance/customerRefunds/rejectedCustomerRefundCandidates/rejectedCustomerRefundCandidateDetailViewModel";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatAmount } from "utils/localizations";

const FuelTypeSection: ViewComponent<CustomerRefundCandidateDetailViewModel | RejectedCustomerRefundCandidateDetailViewModel> =
  observer(({ vm }) => {
    return (
      <Form>
        <Section className="mb-4" title={vm.translate("fuelTypeChange")} context={vm.item.requestedPriceListItemId}>
          <Form.Row>
            <Form.Group as={Col} xs={6}>
              <Form.Label>{vm.translate("fuelType")}</Form.Label>
              <FakeInput
                target={vm.item}
                property="requestedPriceListItemId"
                valueFormatter={value => vm.translateFuelType(value)}
              />
            </Form.Group>
            <Form.Group as={Col} xs={6}>
              <Form.Label>{vm.translate("price")}</Form.Label>
              <FakeInput
                target={vm.item}
                property="requestedPriceListItemId"
                valueFormatter={value => (value ? formatAmount(vm.getPriceListPrice(value)) : 0)}
              />
            </Form.Group>
          </Form.Row>
        </Section>
      </Form>
    );
  });

export default FuelTypeSection;
